const collectionSharingActions = {
  ADD_COLLECTION_MEMBERS: 'ADD_COLLECTION_MEMBERS',
  FETCH_COLLECTION_MEMBERS: 'FETCH_COLLECTION_MEMBERS',
  HIDE_SHARE_COLLECTION: 'HIDE_SHARE_COLLECTION',
  REMOVE_COLLECTION_MEMBER: 'REMOVE_COLLECTION_MEMBER',
  SHARE_COLLECTION: 'SHARE_COLLECTION',
  SHARE_COLLECTION_ERROR: 'SHARE_COLLECTION_ERROR',
  SHARE_COLLECTION_SUCCESS: 'SHARE_COLLECTION_SUCCESS',
  SHOW_COLLECTION_MEMBERS: 'SHOW_COLLECTION_MEMBERS',
  SHOW_COLLECTION_MEMBERS_ERROR: 'SHOW_COLLECTION_MEMBERS_ERROR',
  SHOW_SHARE_COLLECTION: 'SHOW_SHARE_COLLECTION',
  UPDATE_COLLECTION_MEMBER_PERMISSIONS: 'UPDATE_COLLECTION_MEMBER_PERMISSIONS',
  UPDATE_SHARE_COLLECTION_PROPERTIES: 'UPDATE_SHARE_COLLECTION_PROPERTIES',
  UPDATE_CURRENT_COLLECTION_PERMISSIONS: 'UPDATE_CURRENT_COLLECTION_PERMISSIONS',
  UPDATE_COLLECTION_MEMBERS_PROPERTIES: 'UPDATE_COLLECTION_MEMBERS_PROPERTIES',
};

export const collectionDatasetManagementPermissions = {
  DATASETS: 'can_manage_datasets',
};

export const collectionManagementPermissions = {
  INVITE_MEMBER: 'can_invite_user',
  REMOVE_MEMBER: 'can_remove_user',
  SECURITY: 'can_manage_perms',
};

export const collectionAdminPermissions = {
  AUDIT: 'can_read_audit',
  DESTROY: 'can_destroy',
  ...collectionManagementPermissions,
};

export const collectionPermissions = {
  UPDATE: 'can_update',
  ...collectionAdminPermissions,
  ...collectionDatasetManagementPermissions,
};

export const collectionOwnerPermissions = {
  SECURITY: 'can_manage_perms',
};

export const collectionPermissionGroups = {
  DATASETS: [collectionPermissions.DATASETS],
  EDITOR: [collectionPermissions.UPDATE],
  OWNER: Object.values(collectionPermissions),
};

export const collectionPermissionGroupNames = {
  DATASETS: 'DATASETS',
  EDITOR: 'EDITOR',
  OWNER: 'OWNER',
};

export default collectionSharingActions;
